module.exports = __webpack_public_path__ + "static/media/hoopp_logo.fe4f6a04.svg";